export const GET_APPOINTMENT_STARTED = "GET_APPOINTMENT_STARTED"
export const GET_APPOINTMENT_SUCCESS = "GET_APPOINTMENT_SUCCESS"
export const GET_APPOINTMENT_FAILED = "GET_APPOINTMENT_FAILED"